export const join = (...classNames) => classNames.filter((c) => c !== undefined).join(' ');
